import React from "react";

import styled from "styled-components/macro";

import AdditionalDesignationsText from "Giving/AdditionalDesignationsText";

import { useRecurringGifts } from "../RecurringGiftsContext";

export default function FundNameTopArea() {
  const { state } = useRecurringGifts();
  const { currentGift, currentPanel } = state.editModal;
  const paymentType = currentGift?.paymentType;
  const isLoading = !currentGift?.fundName;
  const hasDesinations = currentGift?.designations?.length > 0;
  const fundName = currentGift?.fundName;

  if (isLoading) return null;
  if (currentPanel === "paymentMethods") return null;

  return (
    <Wrapper>
      <EditLine>
        Edit your recurring {paymentType?.toLowerCase() || "payment"} to
      </EditLine>
      <FundName>{fundName}</FundName>
      {hasDesinations && (
        <AdditionalDesignationsText
          designations={currentGift.designations.filter(({ type }) =>
            Boolean(type)
          )}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 14px;
  padding-left: 20px;
  padding-right: 24px;
`;

const EditLine = styled.div`
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 400;
  color: #767676;
`;

const FundName = styled.div`
  font-weight: 600;
  font-size: 28px;
`;
